export const SELECT_PRODUCT_ID = 'SELECT_PRODUCT_ID';
export const SELECT_PB_ID = 'SELECT_PB_ID';
export const SELECT_BILL_ID = 'SELECT_BILL_ID';
export const SELECT_UNIT = 'SELECT_UNIT';
export const SELECT_VERBIAGE = 'SELECT_VERBIAGE';
export const SELECT_TEMP_ACTIVE_PRODUCT_ID = 'SELECT_TEMP_ACTIVE_PRODUCT_ID';
export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const SELECT_BILL = 'SELECT_BILL';
